import{useContext as t}from"react";import{AdvertCardContext as o}from"../contexts/index.js";const r=()=>t(o);export{r as useAdvertCardContext};
